import { ReactNode } from 'react';

import { ImageProps } from '@boss/types/b2b-b2c';
import { TabItemFields } from '@boss/types/corporate-jobs';

import ComponentMapper from '../ComponentMapper';

const getValueCardProps = (
  entry: TabItemFields,
  locale: string,
  hasBackground?: boolean,
): {
  title: string;
  children: ReactNode;
  color?: string;
  icon?: ImageProps;
  className?: string;
  contentClassName?: string;
} => {
  const { tabTitle, backgroundColor, icon, content } = entry;

  return {
    title: tabTitle ?? '',
    color: backgroundColor?.value,
    icon: icon,
    children: content ? <ComponentMapper entry={content} locale={locale} /> : null,
    contentClassName: hasBackground ? 'text-white' : '',
  };
};

export default getValueCardProps;
